<template>
  <div>
    <div class="title">起送金额及配送费用？</div>
    <div class="content-info">
      <p class="txt1">以订单页面显示的起诉金额和配送费用为准。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "register",
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
</style>
